<script setup lang="ts">
import { AppSelect } from '@shared/ui/selects'

import {
  useSelectContactCustomer,
} from '../../../../model/additional-info/support/info-pause-subscription/select-contact-customer.hook'

defineOptions({
  name: 'SelectContactCustomer',
})

const {
  placeholder,
  model,
  options,
} = useSelectContactCustomer()
</script>

<template>
  <AppSelect
    v-model="model"
    :options="options"
    :placeholder="placeholder"
  />
</template>
